import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { CA } from "@/config";
import { shortAddress } from "@/components/Wallet";
import { useLanguage } from "@/i18n/LanguageContext";

// Copyable contract-address chip. full=true renders the entire address.
export default function CaChip({ full = false, testid = "ca-chip", className = "" }) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CA);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* clipboard unavailable */
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      data-testid={testid}
      title={CA}
      className={`mizu-btn inline-flex items-center gap-2 border border-mizu-cyan/25 bg-[#020611]/70 px-4 py-2 font-mono text-[11px] tracking-[0.15em] text-mizu-cyan/90 backdrop-blur-sm ${className}`}
    >
      <span className={full ? "break-all tracking-normal" : ""}>
        CA // {full ? CA : shortAddress(CA)}
      </span>
      {copied ? (
        <Check size={12} className="shrink-0 text-mizu-cyan" />
      ) : (
        <Copy size={12} className="shrink-0 text-mizu-faint" />
      )}
      <span className="sr-only">{copied ? t("wallet.copied") : t("wallet.copy")}</span>
    </button>
  );
}
